import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useClientLogin } from '@/providers/ClientLogin.provider';

const NotFoundRedirect: React.FC = () => {
  const { isAuthenticated } = useClientLogin();
  const history = useHistory();
  useEffect(() => {
    if (!isAuthenticated) {
      const currentPath = history.location.pathname + history.location.search;
      const pathName = history.location.pathname;
      if (pathName === '/login') {
        return;
      }
      history.push(`/login?redirect=${encodeURIComponent(currentPath)}`);
    }
  }, []);

  // Render nothing, as the redirect will happen after the timeout.
  return null;
};

export default NotFoundRedirect;
